module.exports = __webpack_public_path__ + "static/img/Frame-7_7.2738be8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Frame-7_7.gif
// module id = SmBy
// module chunks = 1